import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import get from 'lodash.get';

import { userTypes, contractorLevelEnum } from '../constants';

export function useUserPermissions(id) {
  const userId = useSelector(state => state.auth.check.userId);
  const user = useSelector(state => get(state, `entity.user[${userId}]`, {}));
  const { companyType, companyId, level } = user;
  const isBasicContractor = companyType === userTypes.Contractor && level === contractorLevelEnum.BasicContractor;

  return {
    type: companyType,
    level,
    userCompanyId: companyId,
    isBasicContractor,
    allowUpdate: companyType === userTypes.SafetyCouncil || companyId === id,
  };
}

export function useCheckUserCompany() {
  const { id } = useParams();
  const permissions = useUserPermissions();
  return permissions.update('company', { id });
}
